import * as AppPics from 'assets/images';
import Icons from '../../assets/Icons';

function Html2() {
  return (
    <div className="mainWraper">
      <div className="tab app-l-tab_main">
        <ul className="tab__menu">
          <li className="back">
            <button className="btn-back">
              <img src={AppPics.BackSvg} alt="" />
            </button>
          </li>
          <li className="active">
            Discover <span className="menuWrap__menuIndi">12</span>
          </li>
          <li className="">
            Assess<span className="menuWrap__menuIndi">8</span>
          </li>
          <li className="">
            Perform<span className="menuWrap__menuIndi">23</span>
          </li>
        </ul>
        <div className="tab__content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-6">
                <h2 className="prime-head p-0 boldtitle">Action Centre</h2>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div class="app-l-action-centre-wrapper">
                  <div className="app-l-action-centre-wrapper_items active">
                    <div>Notes</div>
                    <div>
                      <span className="menuWrap__menuIndi">12</span>Action(s) Pending
                    </div>
                    <button className=" btn-primary ">View</button>
                  </div>
                  <div className="app-l-action-centre-wrapper_items active">
                    <div>Geek Corner</div>
                    <div>
                      <span className="menuWrap__menuIndi">12</span>Action(s) Pending
                    </div>
                    <button className=" btn-primary ">View</button>
                  </div>
                  <div className="app-l-action-centre-wrapper_items active">
                    <div>Sprint</div>
                    <div>
                      <span className="menuWrap__menuIndi">12</span>Action(s) Pending
                    </div>
                    <button className=" btn-primary ">View</button>
                  </div>
                  <div className="app-l-action-centre-wrapper_items ">
                    <div>Mindmap</div>
                    <div>No Action Needed</div>
                    <button className=" btn-primary ">View</button>
                  </div>
                  <div className="app-l-action-centre-wrapper_items active">
                    <div>Revision Notes</div>
                    <div>
                      <span className="menuWrap__menuIndi">12</span>Action(s) Pending
                    </div>
                    <button className=" btn-primary ">View</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Html2;
